import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { AddCertificateHolderModal } from './AddCertificateHolderModal'

/** Optional: line up certificate holders now so COIs go out as soon as coverage is active. */
export function CoiStep({ id, onDone }: { id: string; onDone: () => void }) {
  const [isAdding, setIsAdding] = useState(false)

  return (
    <div className="mt-3 flex flex-col items-start gap-3">
      <p className="text-ink-500 text-sm lg:max-w-[400px]">
        Pre-fill customer information so we can send certificates out the moment your coverage is active.
      </p>
      <div className="flex flex-wrap items-center gap-3">
        <Button onClick={() => setIsAdding(true)}>Add certificate holder</Button>
        <Button variant="outline">Upload customer list</Button>
        <Button variant="link" onClick={onDone}>
          Skip
        </Button>
      </div>
      <AddCertificateHolderModal
        id={id}
        open={isAdding}
        onOpenChange={setIsAdding}
        onSave={() => {
          setIsAdding(false)
          onDone()
        }}
      />
    </div>
  )
}
